var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var initialState = {
    data: null,
    isLoading: false,
    error: null,
    selected: null,
};
export var categories = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.LOAD_CATEGORIES:
            return __assign(__assign({}, state), { isLoading: true, error: null });
        case ActionTypes.LOAD_CATEGORIES_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, data: action.payload.data });
        case ActionTypes.LOAD_CATEGORIES_FAILURE:
            return __assign(__assign({}, state), { isLoading: false, error: action.payload.error });
        case ActionTypes.REMOVE_CATEGORIES_ERROR:
            return __assign(__assign({}, state), { error: null });
        case ActionTypes.SELECT_CATEGORY:
            return __assign(__assign({}, state), { selected: action.payload.category });
        default:
            return state;
    }
};
